@optional @link fn getMask(uv: vec2<f32>) -> f32 { return 1.0; };

@infer type T;

@link fn getSurface(
  color: vec4<f32>,
  uv: vec4<f32>,
  st: vec4<f32>,
  normal: vec4<f32>,
  tangent: vec4<f32>,
  position: vec4<f32>,
  coord: vec4<f32>,
) -> @infer(T) T;

@export fn getMaskedSurface(
  color: vec4<f32>,
  uv: vec4<f32>,
  st: vec4<f32>,
  normal: vec4<f32>,
  tangent: vec4<f32>,
  position: vec4<f32>,
  coord: vec4<f32>,
) -> T {
  var surface = getSurface(color, uv, st, normal, tangent, position, coord);

  surface.albedo.a *= getMask(uv.xy);

  return surface;
}
